import { DynamicStyleSheet, variants } from '@pulsar/core';

export default DynamicStyleSheet.create(theme => ({
  root: {
    flexShrink: 0,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.avatarBG,
    ...variants({
      prop: 'size',
      variants: {
        m: {
          height: 40,
          width: 40,
        },
        l: {
          height: 48,
          width: 48,
        },
      },
    }),
  },
}));
